import axios from './axios'
import qs from 'qs'
export default {
    webChatInfo: (req) => {
        return axios.get('/timeAxis/webChatInfo?'+qs.stringify(req))
    },
    webChatMedia: (req) => {
        return axios.get('/timeAxis/webChatMedia?'+qs.stringify(req))
    },
    // /timeAxis/list
    timeAxislist: (req) => {
        return axios.get('/timeAxis/list?'+qs.stringify(req),{ headers: { 'token': '1597086694955703fde1bc2dbd3cb693d0693fd04c0991bd92a61840bb219cb657d21dfe48a8cc4d' } })
    },
}